<div class="card" [routerLink]="currentCardValue?.routerLink">
  <div class="top">
    @if (icon) {
      <div class="icon-wrapper" [ngStyle]="{ backgroundColor: color }">
        <app-icon [src]="icon"></app-icon>
      </div>
    }
    <span class="year">{{ currentCardValue?.year }}</span>
  </div>
  <div class="bottom">
    @if (values && values.length > 1) {
      <div class="indicators">
        @for (value of values; track value) {
          <span
            tabindex="-1"
            [class.active]="value === currentCardValue"
            class="indicator"
            (click)="changeCardValue($event, value)"
            (keydown)="changeCardValue($event, value)">
            <span [ngStyle]="{ backgroundColor: color }">{{ value.unit }}</span>
          </span>
        }
      </div>
    }
    <span class="title" [ngStyle]="{ color }">
      <span>{{ title }}</span>
      @if (values && values.length > 1) {
        <span class="counter"
          >{{ currentCardValueIndex + 1 }} sur {{ values.length }}</span
        >
      }
    </span>
    <span class="value">{{ currentCardValue?.value }}</span>
    <span class="unit">{{ currentCardValue?.unit }}</span>
  </div>
</div>
